// HUB-525: must stay the first import — it turns off Zod's `new Function` probe before any
// schema module loads, so the strict production CSP sees no `eval` violation.
import "@/lib/zod-config";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { buildBrowserSentryOptions, shouldInitializeBrowserSentry } from "@/lib/sentry-config";
import App from "./App";
import "./index.css";
import "./styles/prodigy-adapter.css";

if (shouldInitializeBrowserSentry(import.meta.env)) {
  Sentry.init(buildBrowserSentryOptions(import.meta.env));
}

createRoot(document.getElementById("root")!).render(<App />);
